import React from 'react';
import FileUpload from '@com/property-editor/editor-components/fileupload';
import { IImageUploadProps, IImageUploadService, IImageUploadState } from '@src/slide/application/service/image-upload-service/core/interface';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import { InjectorService, ToolbarService } from '@tencent/workbench';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';

/**
 * 图片上传组件封装
 */
export default class ImageUpload extends React.Component<IImageUploadProps, IImageUploadState> {
    private imageUploadService: IImageUploadService;

    public constructor(props, context) {
        super(props, context);

        this.state = {};
        this.imageUploadService = props.getImageUploadService();
        this.imageUploadService.setViewDelegate(new ReactView(this));
    }

    public render() {
        return (
            <FileUpload
                useForEdit={true}
                key={'-1'}
                maxSize={20000000}
                onChange={this.handleImageChange}
                getImageEditManager={async () => {
                    const copyPasteImageService = await this.imageUploadService.getCopyPasteImageService();
                    return copyPasteImageService.ImageEditManager.getInstance();
                }}
            />
        );
    }

    private handleImageChange = async (e) => {
        await this.imageUploadService.handleImageChange(e);
        const toolbarService = InjectorService.get(ToolbarService);
        toolbarService?.changeRibbonTab(FIXED_KEYS_DOUBLE.TOOLBAR_PICTURE);
    };
}
